import React, { useRef, useState } from "react";
import {
  Button,
  Overlay,
  OverlayTrigger,
  Tooltip,
  UpdatingPopover,
} from "react-bootstrap";

function Index({ text, btnText, placement, classBtn }) {
  const [show, setShow] = useState(false);
  const target = useRef(null);
  return (
    <>
      <Button
        variant="danger"
        className={classBtn}
        ref={target}
        onClick={() => setShow(!show)}
      >
        {btnText}
      </Button>
      <Overlay target={target.current} show={show} placement={placement}>
        <div
          style={{
            backgroundColor: "rgba(255, 100, 100, 0.85)",
            padding: "5px 10px",

            borderRadius: 3,
          }}
          className={"text-dark  border "}
        >
          {text}
        </div>
      </Overlay>
    </>
  );
}

export default Index;
// import React from "react";
// import { OverlayTrigger, PopoverTitle, Button, Popover } from "react-bootstrap";

// function Index(text, btnText, placement, classBtn) {
//   const popover = (
//     <Popover id="popover-basic">
//       {text}
//       wlfawlfmw
//       {/* <Popover.Body>
//         And here's some content. It's very engaging. right?
//       </Popover.Body> */}
//     </Popover>
//   );
//   return (
//     <OverlayTrigger trigger="click" placement={"bottom"} overlay={popover}>
//       <Button className={classBtn} variant="success">
//         {/* {btnText} */}
//       </Button>
//     </OverlayTrigger>
//   );
// }

// export default Index;
